import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { DateLike } from 'modules/types'

dayjs.extend(relativeTime)

export { dayjs }

// --

export const DURATION_UNITS = [
  'second',
  'minute',
  'hour',
  'day',
  'week',
  'month',
  'year'
] as const

export type DurationUnit = typeof DURATION_UNITS[number]

export type Duration = {
  count: number
  unit: DurationUnit
}

export function isStartOf(date: DateLike, unit: DurationUnit) {
  const ref = dayjs(date)
  return ref.isSame(ref.startOf(unit))
}

export function parseDuration(iso: string): Duration | null {
  const match = iso.match(/^P(?:(?:(\d+)([YMWD]))|(?:T(\d+)([HMS])))$/)
  if (!match) {
    return null
  }
  const dateCount = match[1]
  const dateUnit = match[2]
  const timeCount = match[3]
  const timeUnit = match[4]

  if (dateCount && dateUnit) {
    const map: Record<string, DurationUnit> = {
      Y: 'year',
      M: 'month',
      W: 'week',
      D: 'day'
    }
    return {
      count: parseInt(dateCount),
      unit: map[dateUnit]
    }
  }
  if (timeCount && timeUnit) {
    const map: Record<string, DurationUnit> = {
      H: 'hour',
      M: 'minute',
      S: 'second'
    }
    return {
      count: parseInt(timeCount),
      unit: map[timeUnit]
    }
  }
  return null
}

export function serializeDuration({ count, unit }: Duration): string {
  switch (unit) {
    case 'year':
      return `P${count}Y`
    case 'month':
      return `P${count}M`
    case 'week':
      return `P${count}W`
    case 'day':
      return `P${count}D`
    case 'hour':
      return `PT${count}H`
    case 'minute':
      return `PT${count}M`
    case 'second':
      return `PT${count}S`
  }
}
